<template>
  <div class="ripple" :style="`background: ${background};`">
    <div class="ripple_title">
      <slot />
    </div>
    <div>
      <svg
        class="waves"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28"
        preserveAspectRatio="none"
        shape-rendering="auto"
      >
        <defs>
          <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="30" y="0" fill="rgba(255,255,255,0.7" />
          <use xlink:href="#gentle-wave" x="25" y="3" fill="rgba(255,255,255,0.5)" />
          <use xlink:href="#gentle-wave" x="46" y="5" fill="rgba(255,255,255,0.3)" />
          <use xlink:href="#gentle-wave" x="59" y="7" fill="#fff" />
        </g>
      </svg>
    </div>
  </div>
</template>
<script setup lang="ts" name="SmartRipple">
import { ref } from 'vue'

const list = [
  // ['#ff0000','#543ab7'],
  // ['#eec9a3','#ef629f'],
  // ['#bc95c6','#7dc4cc'],
  // ['#c850c0','#4158d0'],
  ['#543ab7', '#00acc1']
]

const initBgColor = () => {
  const color = list[Math.floor(Math.random() * list.length)]
  return `linear-gradient(60deg, ${color[0]} 0%, ${color[1]} 100%)`
}
const background = ref(initBgColor())
</script>
<style scoped lang="less">
.ripple {
  position: relative;
  text-align: center;
  color: white;

  .ripple_title {
    padding-top: 30px;
    font-size: 32px;
    font-weight: bold;
    padding-bottom: 30px;
  }
}

.waves {
  position: relative;
  width: 100%;
  height: 50px;
  margin-bottom: -7px;
  min-height: 50px;
  max-height: 80px;
}

.content a {
  margin: 0 5px;
  font-size: 12px;
  color: #333;
}

.content a:hover {
  color: #000;
}

.parallax > use {
  animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
}

.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 7s;
}

.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 10s;
}

.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 13s;
}

.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 20s;
}

@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}

@media (max-width: 768px) {
  .waves {
    height: 40px;
    min-height: 40px;
  }
}
</style>
